export default "__VITE_ASSET__c53f7c27__"